<template>
  <ion-header class="app-width">
    <ion-toolbar>
      <ion-title>Education Details</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content >
  <div class="app-width">
    <ion-list>
      <ion-item v-for="qi in eduItems" v-bind:key="qi.code" lines="none">
        <template v-if="qi.type === 'grade'">
          <quiz-item-grade-select :quiz-item="qi" v-on:answer="qi._answer = $event"></quiz-item-grade-select>
        </template>
      </ion-item>
    </ion-list>
    </div>
  </ion-content>
  <ion-footer class="app-width">
    <ion-toolbar>
      <ion-button slot="start"  :fill="'outline'" :href="'/account/'">
        <ion-icon :icon="chevronBackOutline"></ion-icon> Back
      </ion-button>
      <ion-button slot="end" v-on:click="proceed()">
        Next <ion-icon :icon="chevronForwardOutline"></ion-icon>
      </ion-button>
    </ion-toolbar>
  </ion-footer>

</template>

<script>
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonFooter,
  IonButton,
  IonIcon,
  IonItem,
  IonList,
  IonContent,
} from '@ionic/vue';
import {
  chevronForwardOutline,
  chevronBackOutline
} from 'ionicons/icons';

import eoppService from "@/mixins/EoppService";
import QuizItemGradeSelect from "@/enrol/QuizItemGradeSelect";
import actRouter from "@/account/ActRouter";

export default {
  name: 'Education',
  components: {
    QuizItemGradeSelect,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonFooter,
    IonButton,
    IonIcon,
    IonItem,
    IonList,
    IonContent,
  },
  mixins: [eoppService],
  data() {
    return {
      chevronForwardOutline,
      chevronBackOutline,
      eduItems:[],
      mirror: true
    };
  },
  mounted() {
    if ( this.lead) {
      this.loadQuizL2();
    } else {
      this.getAccountLead().then(res => {
        console.log(res.data);
        this.$store.commit('leadInfo', res.data);
        this.loadQuizL2();
      })
    }
  },
  methods: {
    back: function () {
      actRouter.push({ path: '/' })
    },
    proceed: function () {
      // console.log(this.eduItems);
      if ( !this.lead.cf.l2 ){
        this.lead.cf.l2 = {}
      }

      (this.eduItems ||[] ).forEach( o => {
        this.lead.cf.l2[o.code] = o._answer;
        console.log(o._answer);
      })

      this.saveLead();
      actRouter.push({ path: '/language' })
    },
    loadQuizL2: function () {

      if ( this.lead.cf && this.lead.cf.pref_program) {
        if ( !this.lead.cf.l2 ){
          this.lead.cf.l2 = {}
        }

        let l2Req = {
          email: this.lead.email,
          programCode: this.lead.cf.pref_program
        }

        this.postData('/data/quiz?type=l2', l2Req).then(res => {
          console.log(res)
          if (res.data && res.data.length > 0) {
            this.eduItems = res.data.filter( qi => qi.type === 'grade');
            this.eduItems.sort((a, b) => a.order - b.order);
            let idx = 1;
            this.eduItems.forEach(o => {
              o.order = idx++;
              o._answer = this.lead.cf.l2[o.code];
            });
          }
        });
      }
    },
    saveLead: function () {
      if (this.lead) {
        console.log(this.lead);
        this.updateCrmRecord([this.lead], null).then(res => {
          console.log(res);
        });
      }
    }
  }
}
</script>
<style>

</style>
